
document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
        setTimeout(() => {
            document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));

            const productForm = document.querySelector("[bss-b2b-quickview-product-form]");
            BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
        }, 1000)
    }

    const label = e.target.closest('[bss-b2b-quickview-product-form] .swatch__option label');
    if (label) {
      const quickViewCard = label.closest('[bss-b2b-quickview-product-form]');
      if (!quickViewCard) return;

      const productFormId = quickViewCard.getAttribute('bss-b2b-product-form-id');
      if (!productFormId) return;

      const productForm = document.querySelector(
        `[bss-b2b-quickview-product-form][bss-b2b-product-form-id="${productFormId}"]`
      );

      if (productForm) {
        console.log('Variant changed -> triggering observer for', productFormId);

        setTimeout(() => {
            BSS_B2B.observer.productSubject.notifyObserver(
                'VariantChange',
                'VariantSelectChange',
                { productForm }
            );
        }, 1000);
      }
    }
  });

  const labels = document.querySelectorAll(`[bss-b2b-main-product-form] .swatch__option label`);
  labels.forEach(label => {
    label.addEventListener('click', function (e) {
        const productForm = document.querySelector("[bss-b2b-main-product-form]");
        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
    });
  });

  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('search__results-wrapper')) {
            window.dispatchEvent(new Event('scroll'))
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }
});



document.addEventListener('DOMContentLoaded', function () {

  const tabs = document.querySelectorAll('.tab-titles li');
  const contents = document.querySelectorAll('.tab-content');

  // URL values (slugs) mapped to your tab IDs
  const tabSlugToId = {
    "all-product-guides": "tab1",
    "everything-dashi": "tab2"
  };

  // reverse map: tab ID -> slug (for click updates)
  const tabIdToSlug = Object.fromEntries(
    Object.entries(tabSlugToId).map(([slug, id]) => [id, slug])
  );

  function activateTab(tabId) {
    tabs.forEach(t => t.classList.remove('active'));
    contents.forEach(c => c.classList.remove('active'));

    const activeTab = document.querySelector(`.tab-titles li[data-tab="${tabId}"]`);
    const activeContent = document.getElementById(tabId);

    if (activeTab && activeContent) {
      activeTab.classList.add('active');
      activeContent.classList.add('active');
    }
  }

  // 1) On load: read ?tab=slug and activate matching tab
  const params = new URLSearchParams(window.location.search);
  const slugFromUrl = (params.get('tab') || '').toLowerCase().trim();
  const tabIdFromSlug = tabSlugToId[slugFromUrl];

  if (tabIdFromSlug) {
    activateTab(tabIdFromSlug);
  } else {
    activateTab("tab1"); // fallback
  }

  // 2) On click: activate and update URL with slug (not tab1/tab2)
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      const tabId = this.getAttribute('data-tab');

      activateTab(tabId);

      const slug = tabIdToSlug[tabId] || "all-product-guides";
      history.pushState({}, '', `${window.location.pathname}?tab=${slug}`);
    });
  });

});


